import { render, staticRenderFns } from "./ClientRegistration.vue?vue&type=template&id=522068a2&scoped=true&"
import script from "./ClientRegistration.vue?vue&type=script&lang=js&"
export * from "./ClientRegistration.vue?vue&type=script&lang=js&"
import style0 from "./ClientRegistration.vue?vue&type=style&index=0&id=522068a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522068a2",
  null
  
)

export default component.exports